<template>
	<Card>
		<div style="width: 450px" class="yl-flex flex_between">

			<Select v-model="city" style="width: 100px;margin-left: 10px;">
				<Option v-for="item in cityList" :value="item.city" :key="item.city">
					{{ item.city}}
				</Option>
			</Select>
			<Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</Button>
			<Button @click="initSearch" style="margin-left: 10px;">重置</Button>
			<Button type="primary" @click="addSingleDefaultCityDemand" style="margin-left: 10px;">添加默认报价</Button>
			<Button type="primary" @click="demandCover" style="margin-left: 10px;">需求同步</Button>
			<Button type="primary" @click="lookHistoryData" v-if="userInfo.role_type != 15"
				style="margin-left: 10px;">查看历史数据优质率</Button>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Checkbox-group v-model="selectDay">
				<Checkbox label="1">星期一</Checkbox>
				<Checkbox label="2">星期二</Checkbox>
				<Checkbox label="3">星期三</Checkbox>
				<Checkbox label="4">星期四</Checkbox>
				<Checkbox label="5">星期五</Checkbox>
				<Checkbox label="6">星期六</Checkbox>
				<Checkbox label="7">星期天</Checkbox>
			</Checkbox-group>
			<div style="margin-bottom: 20px;margin-left: 80%;">
				<Button type="primary" v-if="editStatus ==0" @click="checkThreePlus" style="margin-left: 10px;"> <span
						v-if="checkThreePlusStatus == false">查看</span><span
						v-if="checkThreePlusStatus == true">隐藏</span>优质率</Button>
				<Button type="primary" v-if="editStatus ==0" @click="editData" style="margin-left: 10px;">修改</Button>
				<Button type="primary" v-if="editStatus ==1" @click="saveAllDemand"
					style="margin-left: 10px;">保存</Button>
				<Button type="primary" v-if="editStatus ==1" @click="() => {editStatus = 0}"
					style="margin-left: 10px;">取消</Button>
			</div>
			<Tabs value="name1" @on-click="tabClick">
				<TabPane label="数量指标" name="name1"></TabPane>
				<TabPane label="优质率指标" name="name3"></TabPane>
				<TabPane label="成本指标" name="name2"></TabPane>
			</Tabs>
			<Table :columns="defaultColumns" :data="datas" ref="table" :cellClassName="rowClassName">
				<template slot-scope="{ row,index }" slot="gjj">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(1,row.stop_status_1,row)"
						:class="{'second': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0}">
						<div
							:class="{'second': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0,'is_stop_city':row.stop_status_1 == 1}">
							<Input v-if="editStatus ==1" v-model="datas[index].gjj_form_num"></Input>
							<span v-if="editStatus ==0"><span
									v-if="row.current_gjj_form_num >= 0 &&row.gjj_form_num != 0">{{row.current_gjj_form_num}}/</span><span
									v-if="row.gjj_form_num == 0">
									<Icon type="md-close" style="color: red;" size="30" />
								</span><span v-if="row.gjj_form_num != 0">{{row.gjj_form_num}}</span></span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_gjj_form_num > 0"
								:class="{'check-threeplus-false':row.current_gjj_form_num < row.gjj_form_num,'check-threeplus-true': (row.current_gjj_form_num >= row.gjj_form_num)&&row.gjj_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_gjj_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_gjj_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].gjj_form_cost"></Input>
						<span v-if="editStatus ==0">{{row.gjj_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].gjj_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.gjj_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="fangdi">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(2,row.stop_status_2,row)"
						:class="{'second': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0}">
						<div
							:class="{'second': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0,'is_stop_city':row.stop_status_2 == 1}">
							<Input v-if="editStatus ==1" v-model="datas[index].fangdi_form_num">
							</Input>
							<span v-if="editStatus ==0"><span
									v-if="row.current_fangdi_form_num >= 0 &&row.fangdi_form_num != 0">{{row.current_fangdi_form_num}}/</span><span
									v-if="row.fangdi_form_num == 0">
									<Icon type="md-close" style="color: red;" size="30" />
								</span><span v-if="row.fangdi_form_num != 0">{{row.fangdi_form_num}}</span></span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_fangdi_form_num > 0"
								:class="{'check-threeplus-false':row.current_fangdi_form_num < row.fangdi_form_num,'check-threeplus-true': (row.current_fangdi_form_num >= row.fangdi_form_num)&&row.fangdi_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_fangdi_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_fangdi_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].fangdi_form_cost">
						</Input>
						<span v-if="editStatus ==0">{{row.fangdi_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].fangdi_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.fangdi_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="chedi">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(3,row.stop_status_3,row)"
						:class="{'second': (row.current_chedi_form_num >= row.chedi_form_num)&&row.chedi_form_num != 0,'is_stop_city':row.stop_status_3 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].chedi_form_num">
						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_chedi_form_num >= 0 &&row.chedi_form_num != 0">{{row.current_chedi_form_num}}/</span><span
								v-if="row.chedi_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.chedi_form_num != 0">{{row.chedi_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_chedi_form_num > 0"
								:class="{'check-threeplus-false':row.current_chedi_form_num < row.chedi_form_num,'check-threeplus-true': (row.current_chedi_form_num >= row.chedi_form_num)&&row.chedi_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_chedi_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_chedi_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].chedi_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.chedi_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].chedi_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.chedi_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="qiye">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(4,row.stop_status_4,row)"
						:class="{'second': (row.current_qiye_form_num >= row.qiye_form_num)&&row.qiye_form_num != 0,'is_stop_city':row.stop_status_4 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].qiye_form_num">
						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_qiye_form_num >= 0 &&row.qiye_form_num != 0">{{row.current_qiye_form_num}}/</span><span
								v-if="row.qiye_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.qiye_form_num != 0">{{row.qiye_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_qiye_form_num > 0"
								:class="{'check-threeplus-false':row.current_qiye_form_num < row.qiye_form_num,'check-threeplus-true': (row.current_qiye_form_num >= row.qiye_form_num)&&row.qiye_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_qiye_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_qiye_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].qiye_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.qiye_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].qiye_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.qiye_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="zonghe">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(5,row.stop_status_5,row)"
						:class="{'second': (row.current_zonghe_form_num >= row.zonghe_form_num)&&row.zonghe_form_num != 0,'is_stop_city':row.stop_status_5 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].zonghe_form_num">

						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_zonghe_form_num >= 0 &&row.zonghe_form_num != 0">{{row.current_zonghe_form_num}}/</span><span
								v-if="row.zonghe_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.zonghe_form_num != 0">{{row.zonghe_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_zonghe_form_num > 0"
								:class="{'check-threeplus-false':row.current_zonghe_form_num < row.zonghe_form_num,'check-threeplus-true': (row.current_zonghe_form_num >= row.zonghe_form_num)&&row.zonghe_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_zonghe_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_zonghe_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].zonghe_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.zonghe_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].zonghe_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.zonghe_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="pyq">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(6,row.stop_status_6,row)"
						:class="{'second': (row.current_pyq_form_num >= row.pyq_form_num)&&row.pyq_form_num != 0,'is_stop_city':row.stop_status_6 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].pyq_form_num">

						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.pyq_form_num >= 0 &&row.pyq_form_num != 0">{{row.current_pyq_form_num}}/</span><span
								v-if="row.pyq_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.pyq_form_num != 0">{{row.pyq_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_pyq_form_num > 0"
								:class="{'check-threeplus-false':row.current_pyq_form_num < row.pyq_form_num,'check-threeplus-true': (row.current_pyq_form_num >= row.pyq_form_num)&&row.pyq_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_pyq_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_pyq_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].pyq_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.pyq_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].pyq_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.pyq_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="shebao">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(7,row.stop_status_7,row)"
						:class="{'second': (row.current_shebao_form_num >= row.shebao_form_num)&&row.shebao_form_num != 0,'is_stop_city':row.stop_status_7 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].shebao_form_num">
						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_shebao_form_num != 0 &&row.shebao_form_num != 0">{{row.current_shebao_form_num}}/</span><span
								v-if="row.shebao_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.shebao_form_num != 0">{{row.shebao_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_shebao_form_num > 0"
								:class="{'check-threeplus-false':row.current_shebao_form_num < row.shebao_form_num,'check-threeplus-true': (row.current_shebao_form_num >= row.shebao_form_num)&&row.shebao_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_shebao_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_shebao_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].shebao_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.shebao_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].shebao_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.shebao_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="xueli">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(8,row.stop_status_8,row)"
						:class="{'second': (row.current_xueli_form_num >= row.xueli_form_num)&&row.xueli_form_num != 0,'is_stop_city':row.stop_status_8 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].xueli_form_num">
						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_xueli_form_num >= 0 &&row.xueli_form_num != 0">{{row.current_xueli_form_num}}/</span><span
								v-if="row.xueli_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.xueli_form_num != 0">{{row.xueli_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_xueli_form_num > 0"
								:class="{'check-threeplus-false':row.current_xueli_form_num < row.xueli_form_num,'check-threeplus-true': (row.current_xueli_form_num >= row.xueli_form_num)&&row.xueli_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_xueli_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_xueli_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].xueli_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.xueli_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].xueli_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.xueli_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="gongxin">
					<div v-if="tabNum ==1" style="cursor: pointer;" @click="stopCityDemand(9,row.stop_status_9,row)"
						:class="{'second': (row.current_gongxin_form_num >= row.gongxin_form_num)&&row.gongxin_form_num != 0,'is_stop_city':row.stop_status_9 == 1}">
						<Input v-if="editStatus ==1" v-model="datas[index].gongxin_form_num">
						</Input>
						<span v-if="editStatus ==0"><span
								v-if="row.current_gongxin_form_num >= 0 &&row.gongxin_form_num != 0">{{row.current_gongxin_form_num}}/</span><span
								v-if="row.gongxin_form_num == 0">
								<Icon type="md-close" style="color: red;" size="30" />
							</span><span v-if="row.gongxin_form_num != 0">{{row.gongxin_form_num}}</span></span>
						<div v-if="checkThreePlusStatus == true">
							<div v-if="row.current_gongxin_form_num > 0"
								:class="{'check-threeplus-false':row.current_gongxin_form_num < row.gongxin_form_num,'check-threeplus-true': (row.current_gongxin_form_num >= row.gongxin_form_num)&&row.gongxin_form_num != 0}">
								<div class="three-label">
									三<span>{{row.current_gongxin_threeplus}}</span>
								</div>
								<div class="two-label">
									二<span>{{row.current_gongxin_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].gongxin_form_cost">

						</Input>
						<span v-if="editStatus ==0">{{row.gongxin_form_cost}}</span>
					</div>
					<div v-if="tabNum ==3">
						<Input v-if="editStatus ==1" v-model="datas[index].gongxin_three_plus_rate"></Input>
						<span v-if="editStatus ==0">{{row.gongxin_three_plus_rate}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="remark">
					<div v-if="tabNum ==1">
						<Input v-if="editStatus ==1" v-model="datas[index].remark">
						</Input>
						<span v-if="editStatus ==0">{{row.remark}}</span>
					</div>
					<div v-if="tabNum ==2">
						<Input v-if="editStatus ==1" v-model="datas[index].remark">
						</Input>
						<span v-if="editStatus ==0">{{row.remark}}</span>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="all">
					<div v-if="tabNum ==1"
						:class="{'second': (row.current_form_num >= row.demand_form_num)&&row.demand_form_num != 0}">
						<div>
							<span>{{row.current_form_num}}/{{row.demand_form_num}}</span>
						</div>
						<div v-if="checkThreePlusStatus == true">
							<div>
								<div style="color: #000000;">
									三<span>{{row.current_all_threeplus}}</span>
								</div>
								<div style="color: #66cc00;">
									二<span>{{row.current_all_twoplus}}</span>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template slot-scope="{ row,index }" slot="action">
					<div v-if="tabNum ==1">
						<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
							:data-index="index" @click="editDemandToZero(row)"
							v-if="userInfo.role_type == 1">一键暂停</Button>
					</div>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal v-model="addSingleDefaultCostModal" title="添加默认需求">
			<Form :model="formItem" :label-width="100">
				<FormItem label="投放时间">
					<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
						<span>全选</span>
					</Checkbox>
					<CheckboxGroup v-model="formItem.day_type" @on-change="checkAllGroupChange">
						<Checkbox v-for="item in dayList" :label="item.value"><span>{{item.label}}</span></Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="投放产品">
					<Checkbox :value="checkAllCidType" @click.prevent.native="handleCheckAllCidType"
						:indeterminate="indeterminateCidType">
						<span>全选</span>
					</Checkbox>
					<CheckboxGroup v-model="formItem.adv_type" @on-change="checkAllGroupChangeCidType">
						<Checkbox v-for="item in cidTypeList" :label="item.id"><span>{{item.type}}</span></Checkbox>
					</CheckboxGroup>
				</FormItem>
				<FormItem label="城市">
					<Select v-model="formItem.city" style="width: 200px;margin-left: 10px;">
						<Option v-for="item in cityList" :value="item.city" :key="item.city">
							{{ item.city}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="数量">
					<Input v-model="formItem.form_num" style="width: 200px;margin-left: 10px;">
					<span slot="append">条</span>
					</Input>
				</FormItem>
				<FormItem label="价格">
					<Input v-model="formItem.form_cost" style="width: 200px;margin-left: 10px;">
					<span slot="append">元</span>
					</Input>
				</FormItem>
				<FormItem label="优质率">
					<Input v-model="formItem.three_plus_rate" style="width: 200px;margin-left: 10px;">
					<span slot="append">%</span>
					</Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="saveSingleDefaultDemand">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="demandCoverModal" title="需求同步">
			<Form :model="formItem" :label-width="100">
				<FormItem label="同步时间">
					<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate">
						<span>全选</span>
					</Checkbox>
					<CheckboxGroup v-model="copyTime" @on-change="checkAllGroupChange">
						<Checkbox v-for="item in dayList" :label="item.value"><span>{{item.label}}</span></Checkbox>
					</CheckboxGroup>
				</FormItem>
			</Form>
			<Form :model="formItem" :label-width="100">
				<FormItem label="同步源">
					<Select v-model="copySourceTime" style="width: 100px;margin-left: 10px;">
						<Option v-for="item in dayList" :value="item.value" :key="item.value">
							{{ item.label}}
						</Option>
					</Select>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="saveDemandCover">提交</Button>
				<Button type="default" @click="modal = false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="lookHistoryDataModal" width="1300px" title="历史数据优质率">
			<advHistoryData></advHistoryData>
		</Modal>
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../api/runSet";
	import {
		getDefaultCityDemandList,
		saveSingleDefaultDemand,
		getCidTypeList,
		saveAllDemand,
		saveDemandCover,
		editDemandToZero,
		stopCityDemand
	} from "../../api/advManage.js";
	import advHistoryData from "./components/advHistoryData.vue"; //
	import advPlanManage from "./AdvPlanManage.vue"; //
	import cityData from "../../assets/citydata";

	export default {
		name: "adv_demand_manage",
		components: {
			advHistoryData,
			advPlanManage
		},

		data() {
			return {
				datas: [],
				page: 1,
				pageSize: 20,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				city: '',
				advCity: '',
				selectDay: [],
				copyTime: [],
				copySourceTime: [],
				tabNum: 1,
				addSingleDefaultCostModal: false,
				formItem: {
					day_type: [],
					adv_type: [],
					city: '',
					form_num: '',
					form_cost: '',
					three_plus_rate: '',
				},
				indeterminate: true,
				checkAll: false,
				indeterminateCidType: true,
				checkAllCidType: false,
				demandCoverModal: false,
				lookHistoryDataModal: false,
				checkThreePlusStatus: false,
				dayList: [{
						value: 1,
						label: '星期一'
					},
					{
						value: 2,
						label: '星期二'
					},
					{
						value: 3,
						label: '星期三'
					},
					{
						value: 4,
						label: '星期四'
					},
					{
						value: 5,
						label: '星期五'
					},
					{
						value: 6,
						label: '星期六'
					},
					{
						value: 7,
						label: '星期天'
					},
				],
				cityList: [],
				cidTypeList: [],
				defaultColumns: [{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "总数",
						"slot": "all",
						"align": 'center',
					},
					{
						"title": "时间",
						"key": "day",
						"align": 'center',
					},
					{
						"title": "备注",
						"slot": "remark",
						"align": 'center',
						"width": '200px'
					},
					{
						"title": "操作",
						"slot": "action",
						"align": 'center',
						"width": '200px'
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();

		},
		methods: {

			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				//拼接表头
				console.log(that.cidTypeList);
				for (let i = 0; i < that.cidTypeList.length; i++) {
					var data1 = {};
					data1.title = that.cidTypeList[i].type;
					if (that.cidTypeList[i].type == "公积金") {
						data1.slot = "gjj";
					} else if (that.cidTypeList[i].type == "车抵贷") {
						data1.slot = "chedi";
					} else if (that.cidTypeList[i].type == "房抵贷") {
						data1.slot = "fangdi";
					} else if (that.cidTypeList[i].type == "企业贷") {
						data1.slot = "qiye";
					} else if (that.cidTypeList[i].type == "综合") {
						data1.slot = "zonghe";
					} else if (that.cidTypeList[i].type == "朋友圈") {
						data1.slot = "pyq";
					} else if (that.cidTypeList[i].type == "社保") {
						data1.slot = "shebao";
					} else if (that.cidTypeList[i].type == "学历贷") {
						data1.slot = "xueli";
					} else if (that.cidTypeList[i].type == "工薪贷") {
						data1.slot = "gongxin";
					}
					data1.align = "center";
					that.defaultColumns.splice(i + 1, 0, data1); //从数组的第二项开始插入
				}
				var nowDay = new Date().getDay()
				if (nowDay == 0) {
					nowDay = 7;
				}
				nowDay = nowDay.toString();
				that.selectDay.push(nowDay)
				console.log(that.selectDay)
				this.getList();
			},
			mySearch(e) {
				this.page = 1;
				this.getList();
			},
			checkThreePlus() {
				if (this.checkThreePlusStatus == false) {
					this.checkThreePlusStatus = true;
				} else if (this.checkThreePlusStatus == true) {
					this.checkThreePlusStatus = false;
				}

			},
			editData() {
				this.editStatus = 1;
			},
			tabClick(e) {
				if (e == "name1") {
					this.tabNum = 1;
				} else if (e == "name2") {
					this.tabNum = 2;
				} else if (e == "name3") {
					this.tabNum = 3;
				}
			},
			async stopCityDemand(adv_type, stop_status, row) {
				let that = this;
				if (that.editStatus == 1) {
					return;
				}
				if (that.userInfo.role_type != 1) {
					return;
				}
				console.log(stop_status)
				if (adv_type == 1) {
					var city = row.city + '公积金'
				} else if (adv_type == 2) {
					var city = row.city + '房抵'
				} else if (adv_type == 3) {
					var city = row.city + '车抵'
				} else if (adv_type == 4) {
					var city = row.city + '企业'
				} else if (adv_type == 5) {
					var city = row.city + '综合'
				} else if (adv_type == 6) {
					var city = row.city + '朋友圈'
				} else if (adv_type == 7) {
					var city = row.city + '社保'
				}
				if (stop_status == 0 || stop_status == undefined) {
					row.stop_status = 1;
					var title = '确认要暂停' + city + '产品吗？'
				} else if (stop_status == 1) {
					row.stop_status = 0;
					var title = '确认要启动' + city + '产品吗？'
				}
				row.adv_type = adv_type
				that.$Modal.confirm({
					title: title,
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								data: row
							};
							console.log(row)
							let res = await stopCityDemand(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 1000);
					}
				})
			},
			rowClassName(row, index) {
				if (row.pyq_form_num == 0) {
					return "table-blue-row";
				} else {
					return "table-black-row";
				}
			},
			initSearch() {
				this.city = '';
				this.checkThreePlusStatus = false;
				this.getList();
			},
			addSingleDefaultCityDemand() {
				this.addSingleDefaultCostModal = true;
			},
			demandCover() {
				this.demandCoverModal = true;
			},
			lookHistoryData() {
				this.lookHistoryDataModal = true;
			},
			async getList() {
				let that = this;
				let data = {}
				data.page = that.page
				data.pageSize = that.pageSize
				data.token = that.token;
				data.selectDay = that.selectDay;
				data.city = that.city
				let res = await getDefaultCityDemandList(that, data);
				that.datas = res.data.list;
			},
			async saveAllDemand() {
				let that = this;
				let data = {
					token: that.token,
					data: that.datas
				};
				let res = await saveAllDemand(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.getList();
					this.editStatus = 0;
				}
			},
			async saveDemandCover() {
				let that = this;
				let data = {}
				data.copyTime = that.copyTime
				data.copySourceTime = that.copySourceTime
				data.token = that.token;
				let res = await saveDemandCover(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					this.getList();
					this.demandCoverModal = false;
				}
			},
			async editDemandToZero(row) {
				let that = this;
				that.$Modal.confirm({
					title: '确认要一键暂停吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								data: row
							};
							console.log(row)
							let res = await editDemandToZero(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 1000);
					}
				})
			},
			async saveSingleDefaultDemand() {
				let that = this;

				let data = {
					token: that.token,
					data: that.formItem
				};
				let res = await saveSingleDefaultDemand(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.addSingleDefaultCostModal = false;
					that.getList();
				}
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.dayList) {
						this.formItem.day_type.push(this.dayList[i].value);
					}
				} else {
					this.formItem.day_type = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 7) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			handleCheckAllCidType() {
				if (this.indeterminateCidType) {
					this.checkAllCidType = false;
				} else {
					this.checkAllCidType = !this.checkAllCidType;
				}
				this.indeterminateCidType = false;

				if (this.checkAllCidType) {
					for (let i in this.cidTypeList) {
						this.formItem.adv_type.push(this.cidTypeList[i].id);
					}
				} else {
					this.formItem.adv_type = [];
				}
			},
			checkAllGroupChangeCidType(data) {
				let len = this.cidTypeList.length
				if (data.length === len) {
					this.indeterminateCidType = false;
					this.checkAllCidType = true;
				} else if (data.length > 0) {
					this.indeterminateCidType = true;
					this.checkAllCidType = false;
				} else {
					this.indeterminateCidType = false;
					this.checkAllCidType = false;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			delDefaultCost(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认要删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								id: id
							}
							data.token = this.token;
							let res = await delDefaultCost(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								this.getDefaultAdvCost();
							}
						}, 500)
					}
				})
			},
			saveDefaultCost(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: {
							id: that.defaultData[index].id,
							city: that.defaultData[index].city,
							cid: that.defaultData[index].cid,
							defult_form_cost: that.defaultData[index].defult_form_cost,
						}
					};
					let res = await saveSingleDefaultCost(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.getDefaultAdvCost();
					}
				}, 500)

			},

		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #0055ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: #ffff00;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.first {
		background-color: #d47e83;

		color: #fff;

	}

	.check-threeplus-false {
		color: cornflowerblue;
	}

	.check-threeplus-true {
		color: #fff;
	}

	.second {

		background-color: #277dd3;
		cursor: pointer;
		color: #fff;

	}

	.is_stop_city {
		background-color: #9c4e00;
		cursor: pointer;
		color: #fff;
	}
	
	.three-label{
		color: #5500ff;
	}
	.two-label{
		color: #66cc00;
	}	
</style>